import type { BrandInput } from '@shop-monorepo/types';
import React from 'react';

import { useCreateBrand } from '../../hooks/useBrandQueries';
import { useListReturn } from '../../hooks/useListReturn';
import { ROUTES } from '../../routes/routes';

import { BrandForm } from './BrandForm';

export const CreateBrandForm: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.BRANDS);
  const { mutate: createBrand, isPending: isSubmitting } = useCreateBrand();

  const handleSubmit = async (values: BrandInput) => {
    createBrand(values, {
      onSuccess: () => {
        goToList();
      },
    });
  };

  return <BrandForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
};
